<template>
  <div class="d-flex flex-column pa-6 pa-md-0">
    <v-simple-table class="table">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-sm-body-1 font-weight-bold">Όνομα</th>
            <th class="text-sm-body-1 font-weight-bold">Επίθετο</th>
            <th class="text-sm-body-1 font-weight-bold">Email</th>
            <th class="text-sm-body-1 font-weight-bold">ΑΕΔΑΚ</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user, i) in users" :key="i">
            <td class="text-sm-body-1">
              {{ user.user.firstName }}
            </td>

            <td class="text-sm-body-1">
              {{ user.user.lastName }}
            </td>

            <td class="text-sm-body-1">
              {{ user.user.userEmail }}
            </td>
            <td class="text-sm-body-1">
              <div
                v-for="(creditInstitute, i) in user.creditInstitutes"
                :key="i"
                class="mb-2"
              >
                {{ creditInstitute.mmfManagerNationalName + " ," }}
              </div>
            </td>

            <td class="text-sm-body-1">
              <v-btn
                class="mr-2 mb-2"
                color="primary"
                fab
                x-small
                @click="
                  editDialog = true;
                  currentUser = user;
                "
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>

              <v-btn
                color="error"
                fab
                x-small
                @click="
                  deleteDialog = true;
                  currentUser = user;
                "
                class="mb-2"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-btn
      class="
        success
        rounded
        text-sm-body-1
        font-weight-regular
        align-self-end
        mb-8
        mt-8
      "
      @click="dialog = true"
    >
      <v-icon>mdi-plus</v-icon> <span>Προσθήκη</span>
    </v-btn>

    <v-dialog max-width="700px" v-model="dialog">
      <AddHcmcEmployee @closeDialog="dialog = false" @getUsers="getHcmcUsers" />
    </v-dialog>

    <v-dialog max-width="700px" v-model="editDialog">
      <EditHcmcEmployee
        :currentUser="currentUser"
        v-if="editDialog"
        @closeDialog="editDialog = false"
        @getUsers="getHcmcUsers"
      />
    </v-dialog>

    <v-dialog max-width="500px" v-model="deleteDialog">
      <DeleteHcmcEmployee
        v-if="deleteDialog"
        :currentUser="currentUser"
        @closeDialog="deleteDialog = false"
        @getUsers="getHcmcUsers"
      />
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

import AddHcmcEmployee from "../../components/Modals/Hcmc/AddHcmcEmployee.vue";
import EditHcmcEmployee from "../../components/Modals/Hcmc/EditHcmcEmployee.vue";
import DeleteHcmcEmployee from "../../components/Modals/Hcmc/DeleteHcmcEmployee.vue";

export default {
  components: {
    AddHcmcEmployee,
    EditHcmcEmployee,
    DeleteHcmcEmployee,
  },

  data() {
    return {
      dialog: false,
      editDialog: false,
      deleteDialog: false,

      users: [],

      currentUser: null,
    };
  },

  async created() {
    await this.getHcmcUsers();
  },

  methods: {
    async getHcmcUsers() {
      try {
        const result = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/System/HCMCEmployees`
        );
        this.users = result.data;
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.table {
  width: 800px;
}

@media only screen and (max-width: 960px) {
  .table {
    width: 600px;
  }
}

@media only screen and (max-width: 600px) {
  .table {
    width: 350px;
  }
}
</style>